import { render } from "./CustomSelectOneTestPriority.vue?vue&type=template&id=533cfbfa"
import script from "./CustomSelectOneTestPriority.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneTestPriority.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__